import { render, staticRenderFns } from "./ValueRefund.vue?vue&type=template&id=06f7c1d8&"
import script from "./ValueRefund.vue?vue&type=script&lang=js&"
export * from "./ValueRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports